import { render, staticRenderFns } from "./NotesList.vue?vue&type=template&id=0eadddbe&scoped=true"
import script from "./NotesList.vue?vue&type=script&lang=js"
export * from "./NotesList.vue?vue&type=script&lang=js"
import style0 from "./NotesList.vue?vue&type=style&index=0&id=0eadddbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eadddbe",
  null
  
)

export default component.exports